enum DefaultApiLimit {
  limit = 10,
  page = 1,
}

// Change default export when adding more enum
export default DefaultApiLimit;
